import React from 'react';
import { useSelector } from 'react-redux';

import { useViewportSize } from '@hooks/useViewportSize';

import { getTranslationsState } from '@redux/selectors';

import styles from './CarRentalPartners.module.scss';

const CarRentalPartners: React.FC = () => {
  const translations = useSelector(getTranslationsState);
  const { width } = useViewportSize();

  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <div className={styles.title}>{translations.car_rental_partners}</div>
        {translations.car_rental_partners_description}
      </div>

      <div>
        <img
          src={
            width >= 1280
              ? 'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/car-rentals-partners_357318663.png'
              : 'https://zen.wego.com/cdn-cgi/image/format=auto/cms/images/car-rental-partners-tablet_357322311.png'
          }
          className={styles.image}
          alt={`car-rental-partners`}
        />
      </div>
    </div>
  );
};

export default CarRentalPartners;
